
import { IMRAccordionItemController } from "./accordion-item.controller"
import { COMPONENT_NAME as ACCORDION_COMPONENT_NAME } from '../../accordion.component'

//#region Asset Imports

import './accordion-item.scss'
import * as TEMPLATE from './accordion-item.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrAccordionItem'

export class IMRAccordionItemComponent implements ng.IComponentOptions {
    controller = [IMRAccordionItemController]

    require = {
        parentController: `^^${ACCORDION_COMPONENT_NAME}`
    } as { [index: string]: string }

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE

    transclude = true
}
